import React, { useMemo } from "react";
import { FormControl, ListItemText, MenuItem, Select } from "@mui/material";
import styled from "styled-components";

const StyledSelect = styled(Select)`
  margin: 0px 16px;
  .MuiSelect-outlined {
    padding: 4px 14px;
  }
`;

const renderResponsiveName = (entry) => {
  if (!entry || entry === '') return 'Not defined'
  return `Template ${entry}`;
};

const TemplateVersionsDropDown = ({ onChange, versions, value }) => {
  const sortedVersions = useMemo(() => {
    if (!versions) return null
    return versions.sort((a, b) => b.template_version_id - a.template_version_id)
  }, [versions])

  return (
    <FormControl size="small" variant="outlined">
      <StyledSelect
        value={value?.template_version_id || ''}
        onChange={onChange}
        renderValue={renderResponsiveName}
      >
        <MenuItem value="master">
          <ListItemText primary={`Master Template`} />
        </MenuItem>
        {sortedVersions?.map((entry, index) => (
          <MenuItem key={index} value={entry.template_version_id}>
            <ListItemText primary={`Template ${entry.template_version_id} - ${entry.description}`} />
          </MenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
};

export default TemplateVersionsDropDown;
